// extracted by mini-css-extract-plugin
export default {"preview":"LongTextCell_preview__timpi","fullText":"LongTextCell_fullText__05Edb"};